module.exports = __webpack_public_path__ + "img/pauli-x-root-18.f782752a.svg";